import React from 'react';
import styles from './index.module.scss';
import { ReaderZoomType, ReaderToolType } from 'constants/ReaderTools';
import { EventBus, EventBusType } from 'events/EventBus';
import { ReaderToolsEvent } from 'events/EventTypes';
import { useGAEvent } from 'components/AppService/GAService';

// import rightTop from "assets/icon/four-zoom-in/right-top.svg";
// import rightBottom from "assets/icon/four-zoom-in/right-bottom.svg";
// import leftTop from "assets/icon/four-zoom-in/left-top.svg";
// import leftBottom from "assets/icon/four-zoom-in/left-bottom.svg";

const FourZoomIn = ({ eventBusType = EventBusType.Reader }) => {
    const { gaEvent } = useGAEvent();
    const map = {
        [ReaderZoomType.RightTop]: "/assets/icon/four-zoom-in/right-top.svg",
        [ReaderZoomType.RightBottom]: "/assets/icon/four-zoom-in/right-bottom.svg",
        [ReaderZoomType.LeftTop]: "/assets/icon/four-zoom-in/left-top.svg",
        [ReaderZoomType.LeftBottom]: "/assets/icon/four-zoom-in/left-bottom.svg"
    }

    const fourZoomClickHandler = (type) => {
        gaEvent('工具列_四格放大');
        EventBus.emit({
            eventBusType,
            event: ReaderToolsEvent.SetReaderZoomEvent,
            payload: { type }
        })
    }

    return (
        <div className={styles['four-zoom-in']}>
            <div className={styles.box}>
                <img src={map[ReaderZoomType.LeftTop]} alt="" title="左上角" onClick={() => fourZoomClickHandler(ReaderZoomType.LeftTop)} />
                <img src={map[ReaderZoomType.RightTop]} alt="" title="右上角" onClick={() => fourZoomClickHandler(ReaderZoomType.RightTop)} />
            </div>
            <div className={styles.box}>
                <img src={map[ReaderZoomType.LeftBottom]} alt="" title="左下角" onClick={() => fourZoomClickHandler(ReaderZoomType.LeftBottom)} />
                <img src={map[ReaderZoomType.RightBottom]} alt="" title="右下角" onClick={() => fourZoomClickHandler(ReaderZoomType.RightBottom)} />
            </div>
        </div>
    )
}

export default FourZoomIn;